import app from './App'

export default [
  ...app,
]
